import React from "react";
import AddIcon from "@material-ui/icons/CreateNewFolder";
import {
    Typography,
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemIcon
} from "@material-ui/core";

export class FolderList extends React.Component {
    isActive(e) {
        return e === this.props.activeFolder ? "#ddd" : "white";
    }
    render() {
        const { folders, setFolder, createFolder } = this.props;

        return (
            <Grid item lg={2} md={3} sm={12}>
                <Typography variant="title">Select Folder</Typography>
                <List component="nav">
                    <ListItem
                        key={"all"}
                        button
                        style={{
                            background: this.isActive("all_files")
                        }}
                        onClick={() => {
                            setFolder("all_files");
                        }}
                    >
                        <ListItemText primary={"All Files"} />
                    </ListItem>
                    {folders &&
                        Object.keys(folders).map(e => {
                            return (
                                <ListItem
                                    key={e}
                                    button
                                    style={{
                                        background: this.isActive(e)
                                    }}
                                    onClick={() => {
                                        setFolder(e);
                                    }}
                                >
                                    <ListItemText primary={folders[e]} />
                                </ListItem>
                            );
                        })}
                    <ListItem
                        key={"new"}
                        button
                        onClick={() => {
                            createFolder();
                        }}
                    >
                        <ListItemIcon>
                            <AddIcon />
                        </ListItemIcon>
                        <ListItemText primary={<b>Create Folder</b>} />
                    </ListItem>
                </List>
            </Grid>
        );
    }
}
